import React, { useReducer, useState, useEffect } from 'react';
import style from './CarriageEdit.module.css';
import axios from '../../functions/axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import DropdownList from 'react-widgets/DropdownList';
import { DatePicker, Localization } from 'react-widgets';
import { DateLocalizer } from 'react-widgets/IntlLocalizer';
import 'react-widgets/styles.css';
import './EditCarriage.css';
import { parseDate } from '../../functions/functions';

function EditCarriage() {
  const location = useLocation();
  const [submitting, setSubmitting] = useState(false);
  const [drivers, setDrivers] = useState([]);
  const [cars, setCars] = useState([]);
  const [clients, setClients] = useState([]);
  const navigate = useNavigate();
  const { user } = useAuthContext();

  const formReducer = (state, event) => {
    return {
      ...state,
      [event.name]: event.value,
    };
  };

  const [formData, setFormData] = useReducer(formReducer, {
    day: parseDate(location.state?.day).day,
    //invoiceDate: parseDate(location.state?.invoiceDate || parseDate().addDays(30).day).day,
    routeStart: location.state?.routeStart || '',
    routeEnd: location.state?.routeEnd || '',
    counterStart: location.state?.counterStart || 0,
    counterEnd: location.state?.counterEnd || 0,
    invoice: location.state?.invoice || '',
    documentation: location.state?.documentation || false,
    invoicePay: location.state?.invoicePay || false,
    cost: location.state?.cost || 0,
    oneTimeClient: location.state?.oneTimeClient || '',
    currency: location.state?.currency || 'EUR',
  });

  useEffect(() => {
    if (!user) return null;
    (async () => {
      Promise.all([getData('/driver', setDrivers), getData('/car', setCars), getData('/client', setClients)]);
    })();
  }, [user]);

  const handleSubmit = async (event) => {
    if (event.target.id !== 'submit') return;
    event.preventDefault();
    event.stopPropagation();
    setSubmitting(true);
    await axios.patch(`/carriage`, { ...formData, _id: location.state._id });

    await setTimeout(() => {
      setSubmitting(false);
    }, 3000);
    navigate('/carriageList', { state: { date: formData.day } });
  };

  const handleChange = (event) => {
    const isCheckbox = event.target.type === 'checkbox';
    setFormData({
      name: event.target.name,
      value: isCheckbox ? event.target.checked : event.target.value,
    });
  };

  const handleDeleteCarriage = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (event.target.id !== 'remove') return;

    const confirmBox = window.confirm('Czy chcesz usunąć te dane ?');
    if (confirmBox) {
      await axios.delete(`/carriage`, {
        data: {
          _id: location.state._id,
        },
      });
    }
    navigate('/carriageList', { state: { date: formData.day } });
  };
  const dayChange = new Date(location.state.updatedAt).toLocaleString('pl-PL', { year: 'numeric', month: 'long', day: 'numeric' });
  const timeChange = new Date(location.state.updatedAt).toLocaleString('pl-PL', { hour: 'numeric', minute: 'numeric' });

  return (
    <div className={style.wrapper}>
      <form onSubmit={handleSubmit}>
        <div className={style.section}>
          <h2>Edycja trasy</h2>
          <div className={style.row2}>
            <div>
              <p className={style.category2}>Utworzył: {location.state?.creator?.userName || ''}</p>
              {location.state?.lastEdited?.userName && (
                <p>
                  Edytował: {dayChange} o {timeChange} - {location.state?.lastEdited?.userName}
                </p>
              )}
            </div>
          </div>
          <div className={style.row}>
            <label className={style.category} htmlFor='day-data'>
              Dzień
            </label>
            <Localization
              date={
                new DateLocalizer({
                  culture: 'pl-PL',
                  firstOfWeek: 1,
                })
              }
            >
              <DatePicker
                value={new Date(formData.day)}
                valueEditFormat={{ dateStyle: 'long' }}
                valueDisplayFormat={{ dateStyle: 'long' }}
                placeholder='miesiąc/dzień/rok'
                onChange={(value) => {
                  handleChange({ target: { name: 'day', value: parseDate(value).day } });
                }}
              />
            </Localization>
          </div>
        </div>
        <hr />
        <div className={style.section}>
          <div className={style.row}>
            <label className={style.category} htmlFor='client-data'>
              Klient
            </label>
            <DropdownList
              id='client-data'
              style={{ width: '200px', marginRight: '10px' }}
              defaultValue={formData.client || location.state?.client?._id}
              dataKey='id'
              filter='contains'
              textField='value'
              onChange={(option) => handleChange({ target: { name: 'client', value: option.id } })}
              data={[{ id: 'schema.remove', value: '--Wybierz z listy--' }, ...clients.map((client) => ({ id: client._id, value: client.companyName }))]}
            />
            {/* <label className={style.labelShort} htmlFor='client'>
              lub dodaj klienta:
            </label>
            <input
              id='one-time-client'
              name='oneTimeClient'
              type='text'
              onChange={handleChange}
              defaultValue={location.state?.oneTimeClient || formData.oneTimeClient || ''}
            /> */}
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='timocom-data'>
              TIMOCOM ID:
            </label>
            {/* <div className={style.labelShort}>{timocomID}</div> */}
            <input
              style={{ width: '200px', marginRight: '10px' }}
              id='timocom-data'
              name='timocomID'
              type='text'
              onChange={handleChange}
              value={formData.timocomID ?? location.state?.timocomID ?? location.state?.client?.timocomID ?? ''}
            />
          </div>
        </div>
        <hr />
        <div className={style.section}>
          <div className={style.row}>
            <label className={style.category} htmlFor='car-data'>
              Pojazd:
            </label>
            <DropdownList
              id='car-data'
              style={{ width: '200px', marginRight: '10px' }}
              defaultValue={formData.car ?? location.state?.car?._id}
              dataKey='id'
              filter='contains'
              textField='value'
              onChange={(option) => handleChange({ target: { name: 'car', value: option.id } })}
              data={[{ id: 'schema.remove', value: '--Wybierz z listy--' }, ...cars.map((car) => ({ id: car._id, value: car.plate }))]}
            />
          </div>
        </div>
        <div className={style.section}>
          <div className={style.row}>
            <label className={style.category} htmlFor='driver-data'>
              Kierowca
            </label>
            <DropdownList
              id='car-data'
              style={{ width: '200px', marginRight: '10px' }}
              defaultValue={formData.driver ?? location.state?.driver?._id}
              dataKey='id'
              filter='contains'
              textField='value'
              onChange={(option) => handleChange({ target: { name: 'driver', value: option.id } })}
              data={[{ id: 'schema.remove', value: '--Wybierz z listy--' }, ...drivers.map((driver) => ({ id: driver._id, value: driver.name }))]}
            />
          </div>
        </div>
        <hr />
        <div className={style.section}>
          <div className={style.category}>Opis trasy</div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='route-start-data'>
              Skąd:
            </label>
            <input
              style={{ width: '550px', marginRight: '10px' }}
              id='route-start-data'
              name='routeStart'
              type='text'
              onChange={handleChange}
              defaultValue={formData.routeStart ?? location.state?.routeStart ?? ''}
            />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='route-end-data'>
              Dokąd:
            </label>
            <input
              style={{ width: '550px', marginRight: '10px' }}
              id='route-end-data'
              name='routeEnd'
              type='text'
              onChange={handleChange}
              defaultValue={formData.routeEnd ?? location.state?.routeEnd ?? ''}
            />
          </div>
          {/* <div className={style.row}>
            <label className={style.subcategory} htmlFor='counter-start'>
              Stan początkowy licznika:
            </label>
            <input
              id='counter-start'
              type='number'
              name='counterStart'
              onChange={handleChange}
              defaultValue={formData.counterStart ?? location.state?.counterStart ?? 0}
            />
          </div> */}
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='counter-end'>
              Liczba km:
            </label>
            <input
              id='counter-end'
              type='number'
              name='counterEnd'
              onChange={handleChange}
              defaultValue={formData.counterEnd ?? location.state?.counterEnd ?? 0}
            />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='carriageWeight-data'>
              Waga transportu:
            </label>
            <input
              style={{ width: '150px', marginRight: '10px' }}
              className={style.weight}
              id='carriageWeight-data'
              name='carriageWeight'
              type='text'
              onChange={handleChange}
              defaultValue={formData.carriageWeight ?? location.state?.carriageWeight ?? 0}
            />
          </div>
          <hr />
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='cost-data'>
              Stawka:
            </label>
            <input
              type='number'
              min='0'
              step='any'
              id='cost-data'
              name='cost'
              onChange={handleChange}
              defaultValue={formData.cost ?? location.state?.cost ?? ''}
              disabled={!(user?.permissions?.manageInvoice || user?.permissions?.administrator)}
            />
            <select
              name='currency'
              id='currency'
              defaultValue={location.state.currency || 'EUR'}
              onChange={handleChange}
              disabled={!(user?.permissions?.manageInvoice || user?.permissions?.administrator)}
            >
              <option value='EUR'>EURO €</option>
              <option value='PLN'>PLN zł</option>
            </select>
          </div>
        </div>
        <div className={style.section}>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='invoice-data'>
              Nr faktury
            </label>
            <input
              style={{ width: '150px', marginRight: '10px' }}
              id='invoice-data'
              name='invoice'
              type='text'
              onChange={handleChange}
              defaultValue={formData.invoice ?? location.state?.invoice ?? ''}
              disabled={!(user?.permissions?.manageInvoice || user?.permissions?.administrator)}
            />
          </div>
          <div className={style.row}>
            <label className={style.category} htmlFor='day-data'>
              Termin płatności
            </label>
            <Localization
              date={
                new DateLocalizer({
                  culture: 'pl-PL',
                  firstOfWeek: 1,
                })
              }
            >
              <DatePicker
                value={formData?.invoiceDate ?? location.state?.invoiceDate ? new Date(formData?.invoiceDate ?? location.state?.invoiceDate) : null}
                valueEditFormat={{ dateStyle: 'long' }}
                valueDisplayFormat={{ dateStyle: 'long' }}
                disabled={!(user?.permissions?.manageInvoice || user?.permissions?.administrator)}
                placeholder='miesiąc/dzień/rok'
                onChange={(value) => {
                  handleChange({ target: { name: 'invoiceDate', value: value ? parseDate(value).day : '' } });
                }}
              />
            </Localization>
          </div>
          <hr />
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='documentation_check'>
              Dokumenty
            </label>
            <input
              style={{ width: '150px', marginRight: '10px' }}
              id='documentation_check'
              type='checkbox'
              disabled={!(user?.permissions?.manageInvoice || user?.permissions?.administrator)}
              name='documentation'
              onChange={handleChange}
              checked={formData?.documentation ?? location.state.carriage?.documentation}
            />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='invoicePay_check'>
              Opłacono
            </label>
            <input
              style={{ width: '150px', marginRight: '10px' }}
              id='invoicePay_check'
              type='checkbox'
              disabled={!(user?.permissions?.manageInvoice || user?.permissions?.administrator)}
              name='invoicePay'
              onChange={handleChange}
              checked={formData?.invoicePay ?? location.state.carriage?.invoicePay}
            />
          </div>
          <hr />
          <span className={style.buttons}>
            <button id='cancel' className='btn btn-default' onClick={navigate.bind(null, '/carriageList', { state: { date: formData.day } })}>
              Anuluj
            </button>
            <button id='remove' className={style.removeButton} onClick={handleDeleteCarriage}>
              Usuń dostawę
            </button>
            <button disabled={submitting} id='submit' className='btn btn-default' type='submit' onClick={handleSubmit}>
              Zapisz
            </button>
          </span>
        </div>
      </form>
    </div>
  );
}

const getData = async (path, callback) => {
  try {
    const { data: response } = (await axios.get(path)) || [];
    response.sort((...args) => {
      const [a, b] = args.map(({ name, plate, companyName }) => name || plate || companyName);
      return a.localeCompare(b, 'pl-PL', { sensitivity: 'base' });
    });
    callback(response);
  } catch (error) {
    console.error(error.message);
  }
};

export default EditCarriage;
